<template lang="pug">
  .my-12.text-center.sud-empty-list
    slot
</template>

<script>
export default {
  name: "app-empty-list"
}
</script>

<style scoped>
.sud-empty-list {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  color: #FFFFFF;
}
</style>

